import { calculateMaxDaresByPlatform, calculateMaxDaresForBestPlatform, } from 'root/src/shared/util/calculateMaxDares';
import { useDropEvent, useUserCampaignData } from 'root/src/client/logic/dropEvent/hooks/useDropEvent';
import { DarePlatform } from 'root/src/shared/@types/platforms';
import { useUserCreatorData } from 'root/src/client/logic/auth/hooks/useUser';
import { isDareAnyPlatform, } from 'root/src/shared/drops/helpers/dropDare.helpers';
import { isViewershipPlatform } from 'root/src/shared/platforms/guards/platform.guards';
export function useMaxDaresByPlatforms(params = {}) {
    var _a, _b, _c;
    const { platforms = Object.values(DarePlatform), fallbackDrop } = params;
    const { connectedPlatforms, viewershipPlatforms, averageCcv = 0, averageYoutubeViews = 0, averageYoutubeShortsViews = 0, tiktokFollowers = 0, } = useUserCreatorData();
    const campaign = (_a = useDropEvent()) !== null && _a !== void 0 ? _a : fallbackDrop;
    const userCampaignData = useUserCampaignData();
    if (!campaign) {
        return 0;
    }
    if (isDareAnyPlatform({ platforms })) {
        const bestPlatform = calculateMaxDaresForBestPlatform({
            averageCcv,
            averageYoutubeViews,
            averageYoutubeShortsViews,
            tiktokFollowers,
            campaign,
            connectedPlatforms,
        });
        return (_b = bestPlatform === null || bestPlatform === void 0 ? void 0 : bestPlatform.maxDares) !== null && _b !== void 0 ? _b : 0;
    }
    const maxDaresByPlatform = platforms.map((darePlatform) => {
        if (!isViewershipPlatform(darePlatform)) {
            return campaign.dares
                .filter(dare => dare.platforms.includes(darePlatform)).length;
        }
        if (!viewershipPlatforms.includes(darePlatform)) {
            return 0;
        }
        return calculateMaxDaresByPlatform({
            platform: darePlatform,
            campaign,
            averageYoutubeViews,
            averageYoutubeShortsViews,
            tiktokFollowers,
            averageCcv,
        });
    });
    return Math.max(...maxDaresByPlatform) + ((_c = userCampaignData === null || userCampaignData === void 0 ? void 0 : userCampaignData.extraDares) !== null && _c !== void 0 ? _c : 0);
}
